import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import AsyncSelect from 'react-select/lib/Async';

class AdvocateFiltersForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filters: [
        { title: 'Employer', name: 'provider', type: 'employer',  },
        { title: 'Location', name: 'provider', type: 'location',  },
        { title: 'Filter', name: 'provider', type: 'filter',  },
      ],
      selectedEmployerOption: this.props.selectedEmployerOption,    //(localStorage.getItem('employers') !== "undefined") ? JSON.parse(localStorage.getItem('employers')) : null,
      selectedLocationOption: this.props.selectedLocationOption,    //(localStorage.getItem('locations') !== "undefined") ? JSON.parse(localStorage.getItem('locations')) : null,
      selectedFilterOption: this.props.selectedFilterOption,        // (localStorage.getItem('filters') !== "undefined") ? JSON.parse(localStorage.getItem('filters')) : null,
      type: ''
    };
  }

  onEmployerChange(val) {
    this.setState({ type: 'employer' });
    this.props.change('provider', val);
    this.setState({ selectedEmployerOption: val });
    setTimeout(() => this.props.handleSubmit(this.submit)(), 0);
  }

  onLocationChange(val) {
    this.setState({ type: 'location' });
    this.props.change('provider', val);
    this.setState({ selectedLocationOption: val });
    setTimeout(() => this.props.handleSubmit(this.submit)(), 0);
  }

  onFilterChange(val) {
    this.setState({ type: 'filter' });
    this.props.change('provider', val);
    this.setState({ selectedFilterOption: val });
    setTimeout(() => this.props.handleSubmit(this.submit)(), 0);
  }

  renderEmployerProvider = ({
    input,
    options,
    label,
    selected,
    isMulti,
    meta: { touched, error, warning },
  }) => (
    <div className="provider">
      <AsyncSelect
        isMulti={this.props.isMulti}
        cacheOptions
        defaultOptions
        loadOptions={this.props.searchEmployers}
        getOptionValue={option => option.code}
        getOptionLabel={option => option.name}
        placeholder={label}
        styles={{
          control: styles => ({
            ...styles,
            backgroundColor: 'transparent',
            boxShadow: 'none',
            minHeight: 22,
            minWidth: 260,
          }),
          dropdownIndicator: styles => ({
            ...styles,
            padding: 2,
          }),
          clearIndicator: styles => ({
            ...styles,
            padding: 2,
          }),
          menu: styles => ({
            ...styles,
            zIndex: 99,
            color: '#108ee9'
          }),
        }}
        value={this.state.selectedEmployerOption}
        menuPlacement="top"
        onChange={this.onEmployerChange.bind(this)}
      />
    </div>
  );

  renderLocationProvider = ({
    input,
    options,
    label,
    selected,
    isMulti,
    meta: { touched, error, warning },
  }) => (
    <div className="provider">
      <AsyncSelect
        isMulti={this.props.isMulti}
        cacheOptions
        defaultOptions
        loadOptions={this.props.searchLocations}
        getOptionValue={option => option.code}
        getOptionLabel={option => option.name}
        placeholder={label}
        styles={{
          control: styles => ({
            ...styles,
            backgroundColor: 'transparent',
            boxShadow: 'none',
            minHeight: 22,
            minWidth: 260,
          }),
          dropdownIndicator: styles => ({
            ...styles,
            padding: 2,
          }),
          clearIndicator: styles => ({
            ...styles,
            padding: 2,
          }),
          menu: styles => ({
            ...styles,
            zIndex: 99,
            color: '#108ee9'
          }),
        }}
        value={this.state.selectedLocationOption}
        menuPlacement="top"
        onChange={this.onLocationChange.bind(this)}
      />
    </div>
  );

  renderFilterProvider = ({
    input,
    options,
    label,
    selected,
    isMulti,
    meta: { touched, error, warning },
  }) => (
      <div className="provider">
      <AsyncSelect
          isMulti={this.props.isMulti}
          cacheOptions
          defaultOptions
          loadOptions={this.props.searchFilters}
          getOptionValue={option => option.code}
          getOptionLabel={option => option.name}
          placeholder={label}
          styles={{
            control: styles => ({
              ...styles,
              backgroundColor: 'transparent',
              boxShadow: 'none',
              minHeight: 22,
              minWidth: 260,
            }),
            dropdownIndicator: styles => ({
              ...styles,
              padding: 2,
            }),
            clearIndicator: styles => ({
              ...styles,
              padding: 2,
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99,
              color: '#108ee9'
            }),
          }}
          value={this.state.selectedFilterOption}
          menuPlacement="top"
          onChange={this.onFilterChange.bind(this)}
        />
      </div>
    );

  submit = vals => {
    if (this.state.type === 'employer') {
      const { onEmployerSubmit } = this.props;
      const values = { ...vals };
      return onEmployerSubmit({ ...values });
    }
    if (this.state.type === 'location') {
      const { onLocationSubmit } = this.props;
      const values = { ...vals };
      return onLocationSubmit({ ...values });
    }
    if (this.state.type === 'filter') {
      const { onSubmit } = this.props;
      const values = { ...vals };
      return onSubmit({ ...values });
    }
  };

  render() {
    const { handleSubmit } = this.props;
    const { filters } = this.state;

    return (
      <form onSubmit={handleSubmit(this.submit)} className="telemetry-filters">
        {filters &&
          filters.map((item, i) => {
            if (item.type && item.type === 'employer') {
              return (
                <Field
                  name={item.name}
                  className="form-control"
                  component={this.renderEmployerProvider}
                  key={i}
                  label={item.title}
                />
              );
            }
            if (item.type && item.type === 'location') {
              return (
                <Field
                  name={item.name}
                  className="form-control"
                  component={this.renderLocationProvider}
                  key={i}
                  label={item.title}
                />
              );
            }
            if (item.type && item.type === 'filter') {
              return (
                <Field
                  name={item.name}
                  className="form-control"
                  component={this.renderFilterProvider}
                  key={i}
                  label={item.title}
                />
              );
            }
            return (
              <div className="filter" key={i}>
                <span className="title">{item.title}</span>
              </div>
            );
          })}
      </form>
    );

  }
}

const validate = (values, props) => {
  const errors = {};

  return errors;
};

AdvocateFiltersForm = connect(state => ({
  initialValues: {},
  validate: validate,
}))(reduxForm({ form: 'advocateFiltersForm' })(AdvocateFiltersForm));
export default AdvocateFiltersForm;



// WEBPACK FOOTER //
// ./src/routes/management/components/AdvocateFiltersForm.js